<template>
  <div class="container">
    <builder-content model="page" @on-error="onError" @on-load="onLoad" />
  </div>
</template>

<script setup lang="ts">
import BuilderContent from "~/components/builderContent.vue";
const runtimeConfig = useRuntimeConfig();
const checkPromoAndToken = async (promo: string, token: string) => {
  return useFetch(`${runtimeConfig.public.thorneSite}/partner/promo/valid`, {
    query: {
      'promo-code': promo,
      'partner-token': token,
    },
  }).data.value
}

const writePromoCookie = (promo: string) => {
  let sanitizedPromo = promo.replace(/\s/g, '')
  const existingPromoCookie = useCookie(`thorne_promo-${sanitizedPromo}`)

  if (!existingPromoCookie.value) {

    //a partner cookie was set by a tracking pixel that matched the code set in builder, set the generic session promo cookie
    const newPromoCookie = useCookie(`thorne_promo-${sanitizedPromo}`, {
      maxAge: 60 * 60 * 24,
      path: '/',
      httpOnly: false,
      sameSite: 'lax',
      secure: true
    });

    // Assign the timestamp value to the new cookie
    newPromoCookie.value = `${Date.now()}`;
  }
}

const handlePartnerPromo = async (promo: string, token: string) => {
  // a partner token exists as a parameter on the URL.
  // next we check if the token is valid or already consumed/expired
  // and that the promotion linked to the token
  let result = await checkPromoAndToken(promo, token)
  let isValid = result === promo
  if (isValid) {
    writePromoCookie(promo)
  }
}

const onLoad = async (pageData) => {
  useSeoMeta({
    title: pageData?.data?.title,
    description: pageData?.data?.description
  });

  if (pageData?.data?.partnerCode) {
    const partnerCode = pageData.data.partnerCode as string
    const urlTokenParam = useRequestURL().searchParams.get("token")
    if (urlTokenParam) {
      await handlePartnerPromo(partnerCode, urlTokenParam)
    }
  }

}

const onError = () => {
  if (import.meta.server) {
    showError({ statusCode: 404, statusMessage: 'Page Not Found' });
  }
}
</script>